import type { MagicError } from './magic-login-form.types';
export const MagicLoginError: Record<MagicError, string> = {
  GOOGLE_USER: 'Uh-oh! It looks like you need to login with Google',
  NO_USER: 'Uh-oh! No account was found',
  UNHANDLED_ERROR: 'Uh-oh! Something went wrong, please try again later.'
};